import { onMounted, onUnmounted, Ref, ref } from 'vue';

type VisibilitychangeState = 'hidden' | 'visible' | 'prerender' | 'unloaded'

type VisibilitychangeProps = Ref<VisibilitychangeState>

export const useVisibilitychange = (): VisibilitychangeProps => {
  const state = ref<VisibilitychangeState>(document.visibilityState);

  const update = () => {
    state.value = document.visibilityState;
  };

  onMounted(() => {
    document.addEventListener('visibilitychange', update);
  });

  onUnmounted(() => {
    document.removeEventListener('visibilitychange', update);
  });

  return state
}
